module.exports = __webpack_public_path__ + "img/loader.7e3ecaab.gif";